import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import { useMediaQuery } from "react-responsive";

import { EditMemberContainer } from "../../styled/groupDetails";
import { NoData } from "../../styled/common";

import Search from "../../common/search";
import TableMember from "./members/tableMember";
import ListMember from "./members/listMember";
import { authOptions } from "../../function/group";

const Members = ({
  member,
  members,
  group,
  getGroupMembers,
  setIsInvite,
  openModal,
  closeModal,
}) => {
  const user = useSelector((state) => state?.user?.data[0]);

  const isMobile = useMediaQuery({ query: "(max-width:767px)" });

  const [groupMembers, setGroupMembers] = useState([...members]);
  const [searched, setSearched] = useState("");

  useEffect(() => {
    setGroupMembers([...members]);
  }, [members]);

  // 권한 변경
  const handleAuth = (item, newAuth) => {
    const isMaster = String(member.auth) === "0" && String(newAuth) === "0";

    if (!isMaster && member.auth >= item.auth) {
      toast.error("해당 멤버의 권한을 변경할 수 없습니다.");
      return;
    }
    if (!isMaster && member.auth >= newAuth) {
      toast.error("해당 권한으로는 변경할 수 없습니다.");
      return;
    }

    openModal({
      isOpen: true,
      type: "confirmation",
      title: "권한 변경",
      message: isMaster
        ? [
            `모임 내 최고 관리자는 1명만 가능합니다.`,
            `${`${item.nickNm}님` || "닉네임 미설정"}의 권한을 최고 관리자로 위임하시겠습니까?`,
            `위임할 경우 나의 권한이 부방장으로 변경됩니다.`,
          ]
        : [
            `${`${item.nickNm}님` || "닉네임 미설정"}의 권한을`,
            `${chooseParticle(authOptions[newAuth].label, "으로")} 변경하시겠습니까?`,
          ],
      handleConfirm: () =>
        updateAuth(
          {
            nickNm: item.nickNm || "",
            seq: item.seq,
            groupNo: item.groupNo,
            mberNo: item.mberNo,
            delYn: "N",
            gbnValue: item.gbnValue,
            auth: newAuth,
            isAuthChanged: "Y",
          },
          isMaster,
        ),
      handleCancel: () => closeModal(),
    });
  };

  // 멤버 삭제
  const handleDelete = (item) => {
    if (member.auth >= item.auth) {
      toast.error("해당 멤버는 삭제할 수 없습니다.");
      return;
    }

    openModal({
      isOpen: true,
      type: "confirmation",
      title: "멤버 삭제",
      message: [`멤버 ${`${item.nickNm}님을` || "닉네임 미설정을"}  삭제하시겠습니까?`],
      handleConfirm: () =>
        deleteMember({
          seq: item.seq,
          groupNo: item.groupNo,
          mberNo: item.mberNo,
          delYn: "Y",
          auth: item.auth,
          gbnValue: item.gbnValue,
        }),
      handleCancel: () => closeModal(),
    });
  };

  // 멤버 권한 변경
  const updateAuth = async (update, isMaster = false) => {
    const url = "/api/groupMber";
    const body = {
      ...update,
      createMberId: user.userName,
      updateMberId: user.userName,
      isAuthChanged: "Y",
    };

    try {
      const res = await axios.put(url, body);

      if (res.data.success) {
        if (isMaster) {
          const selfUpdate = {
            nickNm: member.nickNm || "",
            seq: member.seq,
            groupNo: member.groupNo,
            mberNo: member.mberNo,
            delYn: "N",
            gbnValue: member.gbnValue,
            auth: 1,
            isAuthChanged: "Y",
          };
          const selfRes = await axios.put(url, {
            ...selfUpdate,
            createMberId: user.userName,
            updateMberId: user.userName,
          });

          if (!selfRes.data.success) {
            toast.error("본인 권한 변경 중 오류가 발생했습니다.");
            return;
          }
        }

        toast.success("멤버 권한이 변경되었습니다.");
        getGroupMembers(group);
      }
    } catch (error) {
      console.log(error);
    } finally {
      closeModal();
    }
  };

  // 멤버 삭제
  const deleteMember = async (update) => {
    const url = "/api/groupMber";
    const body = {
      ...update,
      createMberId: user.userName,
      updateMberId: user.userName,
    };
    const res = await axios.put(url, body);

    if (res.data.success) {
      toast.success("모임 멤버가 삭제되었습니다.");
      getGroupMembers(group);
      closeModal();
    }
  };

  // 가입한 멤버 검색
  const handleSearch = () => {
    if (searched) {
      setGroupMembers(
        members.filter(
          (user) =>
            (user.nickNm && user.nickNm.includes(searched)) ||
            (user.moblphonNo && user.moblphonNo.includes(searched)),
        ),
      );
    } else {
      setGroupMembers([...members]);
    }
  };

  return (
    <EditMemberContainer>
      <Search
        placeholder="닉네임을 입력해주세요."
        searched={searched}
        setSearched={setSearched}
        handleSearch={handleSearch}
      />
      <button className="invite" onClick={() => setIsInvite(true)}>
        멤버 초대
      </button>
      {isMobile ? (
        groupMembers && groupMembers.length > 0 ? (
          <ul>
            {groupMembers.map((item) => (
              <ListMember
                group={group}
                item={item}
                handleAuthChange={handleAuth}
                handleDeleteChange={handleDelete}
              />
            ))}
          </ul>
        ) : (
          <NoData>멤버가 존재하지 않습니다.</NoData>
        )
      ) : (
        <table>
          <thead>
            <tr>
              <th>이름</th>
              <th>가입날짜</th>
              <th>권한</th>
              <th>삭제</th>
            </tr>
          </thead>
          <tbody>
            {groupMembers && groupMembers.length > 0 ? (
              groupMembers.map((item) => (
                <TableMember
                  group={group}
                  item={item}
                  handleAuthChange={handleAuth}
                  handleDeleteChange={handleDelete}
                />
              ))
            ) : (
              <tr>
                <td colSpan={4}>멤버가 존재하지 않습니다.</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </EditMemberContainer>
  );
};

export default Members;
